// Dependencies
import { FC } from "react";

// types
import { DefaultCategory } from "~/enums";

// Styles
import { StyledIconItem, StyledListWrapper } from "./IconList.styled";

interface IconListProps {
  onSelect: Function;
}

const IconList: FC<IconListProps> = ({ onSelect }) => {
  return (
    <StyledListWrapper>
      {Object.entries(DefaultCategory).map(([categoryId, { name, icon }]) => (
        <div
          onClick={() => onSelect({ target: { value: categoryId } })}
          key={name}
        >
          <StyledIconItem src={icon} />
        </div>
      ))}
    </StyledListWrapper>
  );
};

export default IconList;
